import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  EventEmitter,
  Output,
  OnChanges,
} from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import {
  User,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import {
  ActiveCartFacade,
  MultiCartFacade,
  OrderEntry,
} from '@spartacus/cart/base/root'
import { Observable, Subscription } from 'rxjs'
import { filter, take } from 'rxjs/operators'
import {
  CurrentProductService,
  LaunchDialogService,
} from '@spartacus/storefront'

import { QuoteCartService } from '../../quote/quote-services/quote-cart.service'
import { QuoteCartFacade } from '../mini-cart/store/mini-quote-cart.facade'
import { Router, NavigationEnd } from '@angular/router'
import { ShoppingCartService } from '../cart-shared/cart.service'
import { Actions, ofType } from '@ngrx/effects'
import { PDPService } from '../../pdp/services/pdp.services'
import { BulkServiceService } from '../../bulk-order/bulk-service.service'
import { CartActions } from '@spartacus/cart/base/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { SpinnerOverlayService } from '../../../shared/components/spinner-overlay/spinner-overlay.service'
import { CalenderConfigService } from '../../../shared/services/calender-config.service'
import { userRoles } from '../../../models/user.model'
import { CommonService } from '../../../shared/services/common.service'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'
import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
  GTMCartType
} from '../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../shared/services/gtm.service';

@Component({
  standalone: false,
  selector: 'cx-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToCartComponent implements OnInit, OnDestroy, OnChanges {
  showNotAvailableMsg: boolean
  quantity_unit: any
  constructor(
    protected launchDialogService: LaunchDialogService,
    protected currentProductService: CurrentProductService,
    private cd: ChangeDetectorRef,
    protected activeCartService: ActiveCartFacade,
    public auth: AuthService,
    public commonService: CommonService,
    public quoteService: QuoteCartService,
    public router: Router,
    private multiCartService: MultiCartFacade,
    private occAdapter: OccCartAdapter,
    private globalMessageService: GlobalMessageService,
    private shoppingCartService: ShoppingCartService,
    private spinnerOverlayService: SpinnerOverlayService,
    private actions$: Actions,
    private bulkService: BulkServiceService,
    private calenderConfigService: CalenderConfigService,
    public pdpService: PDPService,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade,
  ) {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current') || undefined
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous') || undefined
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  public checkAvailability: Observable<any>
  @Input() productCode: string
  @Input() showQuantity = true
  @Input() view: string
  @Input() addresses: any
  @Input() checkAvailabilityCRD?: any
  @Output() counterItem = new EventEmitter<any>()
  /**
   * As long as we do not support #5026, we require product input, as we need
   *  a reference to the product model to fetch the stock data.
   */
  @Output() priceNotFound = new EventEmitter<any>()
  cartFlag: boolean = true
  @Input() product
  @Input() legalEntity?: any
  showAvailability = false
  public userRoles = userRoles
  maxQuantity: number
  hasStock = false
  quantity = 1
  increment = false
  cartEntry$: Observable<OrderEntry>

  subscription: Subscription
  addToCartForm = new FormGroup({
    quantity: new FormControl(1),
    availableAt: new FormControl('Select', [Validators.required]),
  })
  user$: Observable<User>
  loggedIn: boolean
  userType: string
  cartId: string
  cartStatus: string
  minDate = new Date()
  checkPriceProduct = {}
  displaySearchLoader: boolean = false
  @Output() emitCheckPriceProductObj = new EventEmitter()
  @Output() priceAvailabilityProductObj = new EventEmitter()
  legalEntityData: any
  committedDate: any = ''
  committedQuantity = 0
  availabilityInfo$: Observable<any>
  hideProductPrice = false
  showCheckPriceLoader = false
  commitedDateToCheck: any
  sellabilityAfterPriceCheck = false
  showDiffPlantWarning = false
  disableBuyBtn: boolean = false
  shippedFrmOptions: any[] = []
  otherInventoryLocations: any[] = []
  @Input() otherLocations: any
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  availabilityDetails: any
  @Output()
  selectedLegalEntityId: EventEmitter<any> = new EventEmitter()
  renderDatePicker: boolean = true
  plpCustomerReqDate: any = ''

  getPriceAndAvailability(productcode) {
    this.shippedFrmOptions = []
    this.otherInventoryLocations = []
    this.availabilityDetails = []
    this.spinnerOverlayService.show()
    const params = ['products']
    let lastPart = `productCode?`
    lastPart += `productCode=${encodeURIComponent(productcode)}`
    params.push(lastPart)
    const apiUrl = this.commonService.constructUrl(params)
    this.checkAvailability = this.commonService.getData(apiUrl)
    this.checkAvailability.subscribe(
      (success: any) => {
        this.product = success
        this.spinnerOverlayService.hide()
        if (!this.product?.availabilityDetail) {
          return
        }
          this.availabilityDetails = this.product?.availabilityDetail
          this.commitedDateToCheck =
          this.product?.availabilityDetail[0].committedDate
          //this.cd.detectChanges();
          this.showAvailability = false
          // this.commonService.priceandAvailabilitySource.next(this.checkAvailability)

        if (this.product?.plantAvailableAt)
        {
          this.legalEntityData = this.product?.plantAvailableAt[0]
          let count = 0
          this.product?.plantAvailableAt?.forEach((element) => {
            if (
              element?.defaultPlant === true &&
              (element.code == this.product?.defaultSalesArea.uid ||
                element.code.slice(0, 3) ==
                  this.product?.defaultSalesArea.uid.slice(0, 3))
            ) {
              count++
              this.legalEntityData = element
              this.selectedLegalEntityId = element.code
            }
            if (
              element.code == this.product?.defaultSalesArea.uid ||
              element.code.slice(0, 3) ==
                this.product?.defaultSalesArea.uid.slice(0, 3)
            ) {
              this.shippedFrmOptions.push(element)
            } else {
              //this.selectedLegalEntityId = undefined
              this.otherInventoryLocations.push(element)
            }
          })

          if (count === 1) {
            this.showNotAvailableMsg = false
            this.addToCartForm.controls.availableAt.setValue(
              this.legalEntityData?.name +
                ' (' +
                (Number(this.legalEntityData?.stockAvailable) || 0) +
                ') '
            )
          } else {
            this.showNotAvailableMsg = true
            this.addToCartForm.controls.availableAt.setValue(
              this.product?.defaultSalesArea?.salesOrganization +
                ' (' +
                'Not available' +
                ') '
            )
          }
        }

        this.checkAvailabilityCall(true);
        this.cd.detectChanges();
        // if (this.userType == 'current' && count === 1) {
        //   this.checkAvailabilityCall(true);
        // }
        // }
        // else {
        //   this.spinnerOverlayService.hide()
        // }
        if (success.errorCode == '500') {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'addCart.sapNotAvailable' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
        if (success.errorCode == '501') {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'addCart.priceNotAvailable' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
        if (success.errorCode == '5001') {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'addCart.priceNotAvailable' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
        window.scrollTo(0, 0)
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'addCart.unknownErrorOccured' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnInit() {  
    this.router.events.subscribe(
      (ev) => {
        if (ev instanceof NavigationEnd) {
          this.quantity = 1
          this.addToCartForm.controls.quantity.setValue(1)
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    if (this.product) {
      this.productCode = this.product.code
      this.cartEntry$ = this.activeCartService.getEntry(this.productCode)
      this.setStockInfo(this.product)
      this.cd.markForCheck()
    } else if (this.productCode) {
      this.cartEntry$ = this.activeCartService.getEntry(this.productCode)
      // force hasStock and quantity for the time being, as we do not have more info:
      this.quantity = 1
      this.hasStock = true
      this.cd.markForCheck()
    } else {
      this.subscription = this.currentProductService
        .getProduct()
        .pipe(filter(Boolean))
        .subscribe(
          (product: any) => {
            this.productCode = product.code
            this.setStockInfo(product)
            this.cartEntry$ = this.activeCartService.getEntry(this.productCode)
            this.cd.markForCheck()
          },
          (error) => {
            this.globalMessageService.add(
              error,
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            window.scrollTo(0, 0)
          }
        )
    }
    if (this.view == 'pdp') {
      // this.getPriceAndAvailability(this.productCode);
    }

    this.hideProductPrice = this.product?.hidePrice
    this.activeCartService.getActiveCartId().subscribe((data) => {
      this.cartId = data
    })
    this.bulkService.vsntriesCart.pipe(take(2)).subscribe((id) => {
      if (id) {
        this.cartFlag = false
        this.addToCartAdapter(this.cartId, this.quantity_unit || 1, null)
      }
    })
  }

  private setStockInfo(product: any): void {
    this.quantity = 1
    this.hasStock =
      product.stock && product.stock.stockLevelStatus !== 'outOfStock'
    if (this.hasStock && product.stock.stockLevel) {
      this.maxQuantity = product.stock.stockLevel
    }
  }

  updateCount(value: number): void {
    this.quantity = value
  }

  openCRDdialog(cartFlag) {
    const componentdata = {};
    let valInstance;
    this.plpCustomerReqDate = '';

    const crdInputDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.CRD_INPUT_MODAL,
      undefined,
      undefined,
      componentdata
    )

    if (crdInputDialog) {
      crdInputDialog.pipe(take(1)).subscribe((value) => {
        valInstance = value.instance.launchDialogService._dialogClose._value;
        if (valInstance.reason == 'crd-selected') {
          this.disableBuyBtn = true;
          this.cd.detectChanges();
          this.plpCustomerReqDate = valInstance.data;
          if(cartFlag === 'buy'){
            this.addToCart();
          } else if(cartFlag === 'quote'){
            this.getQuote();
          }
        }
      })
    }
  }

  addToCart() {
    let buyCartId = ''
    let quantity = this.addToCartForm.get('quantity').value
    if (!this.productCode || quantity <= 0) {
      return
    }

    if (this.view == 'pnaWidget' && this.product.quantity) {
      quantity = this.product.quantity
      this.quantity_unit = this.product.quantity
      this.legalEntityData = this.legalEntity
    }

    // check item is already present in the cart
    // so modal will have proper header text displayed
    this.disableBuyBtn = true;
    this.activeCartService
      .getEntry(this.productCode)
      .subscribe(
        (entry) => {
          if (entry) {
            this.increment = true
          }
          // OOTB method
          // this.openModal();
          // this.activeCartService.addEntry(this.productCode, quantity);

          this.activeCartService
            .getActiveCartId()
            .pipe(take(1))
            .subscribe((res: any) => {
              if (res) {
                buyCartId = res
                this.addToCartAdapter(buyCartId, quantity)
              } else {
                this.occAdapter
                  .create('current')
                  .pipe(take(1))
                  .subscribe((occData) => {
                    buyCartId = occData.code
                    this.addToCartAdapter(buyCartId, quantity)
                    this.multiCartService.loadCart({
                      userId: 'current',
                      cartId: buyCartId,
                      extraData: {
                        active: true,
                      },
                    })
                  })
              }
            })

          this.increment = false
        },
        (error) => {
          this.disableBuyBtn = false
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scrollTo(0, 0)
        }
      )
      .unsubscribe()
  }

  addToCartAdapter(cartId, quantity, legalEntity?) {
    const quoteCartType = sessionStorage.getItem('quoteCartType')
    const isRfqCart = sessionStorage.getItem('isRfqCart')
    const urlParam = ['users', this.userType, 'carts', cartId, 'vsentries']
    const url = this.commonService.constructUrl(urlParam)
    this.quantity_unit = quantity
    const apiParams: any = {
      quantity,
      product: {
        code: this.product.code,
      },
      //selectedLegalEntity: this.legalEntityData,
      selectedPlant: this.legalEntityData,
      customerRequestedDate: ['pdp'].includes(this.view) ? this.product?.committedDate : (['pnaWidget'].includes(this.view) ? this.checkAvailabilityCRD : this.plpCustomerReqDate),
    }
    if (
      quoteCartType != '' &&
      quoteCartType != 'undefined' &&
      isRfqCart == 'false'
    ) {
      this.deleteCart(cartId, quantity)
    } else {
      this.commonService
        .postData(url, apiParams)
        .pipe(take(1))
        .subscribe(
          (result) => {
            this.cartEntry$ = this.activeCartService.getEntry(this.productCode)
            this.pushAddToCartEvent(result["entry"], 'buy', cartId);
            this.openModal()
            this.disableBuyBtn = false
            this.cd.detectChanges()
          },
          (er) => {
            let errorMsg = ''
            if (er.error?.errors[0]?.message == '5001') {
              errorMsg = 'addCart.noPriceFoundInSAP'
              if (errorMsg) {
                this.globalMessageService.add(
                  { key: errorMsg },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  10000
                )
                window.scroll(0, 0)
              }
            } else if (er.error?.errors[0]?.message == '500') {
              errorMsg = 'addCart.lostConnectivity'
              if (errorMsg) {
                this.globalMessageService.add(
                  { key: errorMsg },
                  GlobalMessageType.MSG_TYPE_ERROR,
                  10000
                )
                window.scroll(0, 0)
              }
            } else {
              this.disableBuyBtn = false
              this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
            }
          }
        )
    }
  }
  deleteCart(cartId, quantity) {
    // this.OpenPopUp = false;
    this.spinnerOverlayService.show()
    this.multiCartService.deleteCart(cartId, this.userType)
    this.actions$
      .pipe(ofType(CartActions.DELETE_CART_SUCCESS))
      .pipe(take(1))
      .subscribe((r) => {
        sessionStorage.setItem('quoteCartType', '')
        sessionStorage.setItem('isRfqCart', '')
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'addCart.existingCartRemoved' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scroll(0, 0)
        this.occAdapter
          .create('current')
          .pipe(take(1))
          .subscribe((occData) => {
            cartId = occData.code
            sessionStorage.setItem('quoteCartType', '')
            sessionStorage.setItem('isRfqCart', '')
            this.addToCartAdapter(cartId, quantity)
            this.multiCartService.loadCart({
              userId: 'current',
              cartId: cartId,
              extraData: {
                active: true,
              },
            })
          })
      })

    this.actions$
      .pipe(ofType(CartActions.DELETE_CART_FAIL))
      .pipe(take(1))
      .subscribe(
        (r) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'addCart.clearCartFailed' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  getQuote() {
    this.cartId = sessionStorage.getItem('cartId-' + this.userType)
    this.quoteService
      .getCart(this.cartId, this.userType)
      .subscribe((success: any) => {
        if (this.loggedIn || this.userType === 'current') {
          this.cartId = success['code']
          sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        }
        if (!this.loggedIn || this.userType === 'anonymous') {
          this.cartId = success['guid']
          sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        }
        sessionStorage.setItem('cartStatus-' + this.userType, 'added')
        this.openQuoteModal()
      })
  }
  navigateToReplacement() {
    this.router.navigateByUrl(this.product.replacementProductUrl)
  }
  openQuoteModal() {
    let qty = this.addToCartForm.get('quantity').value
    if (this.view == 'pnaWidget' && this.product.quantity) {
      qty = this.product.quantity
    }
    let obj = {
      product: this.product,
      userType: this.userType,
      cartId: this.cartId,
      type: 'catalog',
      quantity: qty,
      crd: this.plpCustomerReqDate,
      view: this.view
    }
    this.commonService.sendProduct(obj)
    const componentdata = {}

    const getAQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.GET_A_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (getAQuoteDialog) {
      getAQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }

    this.pushAddToCartEvent(this.product, 'quote', this.cartId);
    setTimeout(() => {
      this.quoteCartFacade.loadCart();
    }, 500);
  }

  private openModal() {
    this.activeCartService
      .getActiveCartId()
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.multiCartService.loadCart({
            userId: 'current',
            cartId: res,
            extraData: {
              active: true,
            },
          })
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scrollTo(0, 0)
        }
      )

    const componentdata = {
      entry$: this.cartEntry$,
      cart$: this.activeCartService.getActive(),
      loaded$: this.activeCartService.isStable(),
      quantity: this.quantity,
      increment: this.increment,
      product: this.product,
    }

    const addToCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ADD_TO_CART,
      undefined,
      undefined,
      componentdata
    )
    if (addToCartDialog) {
      addToCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }

  ngOnDestroy() {
    this.quantity = 1;
    this.committedDate = '';
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    this.availabilityInfo$ = null
    this.legalEntityData = null
    this.bulkService.vsntriesCart.next(false)
    this.cartFlag = true
  }
  ngOnChanges(changes) {
    if (
      changes?.productCode?.currentValue !=
        changes?.productCode?.previousValue &&
      this.view == 'pdp'
    ) {
      this.renderDatePicker = false;
      this.quantity = 1;
      this.committedDate = '';
      this.legalEntityData = null;
      
      setTimeout(() => {
        this.renderDatePicker = true;
        this.cd.detectChanges();
      }, 0);

      this.getPriceAndAvailability(changes?.productCode?.currentValue)
    }
    /*else if(this.view = 'pnaWidget'){
     this.otherInventoryLocations =this.otherLocations;
     }*/
  }
  getCount(event) {
    this.quantity = event
    this.showAvailability = true
    this.commonService.getCount(event)
    this.checkForAvailability()
  }

  // CHECK PRICE CUSTOMIZATION FOR GLOBAL SEARCH  - START

  checkPrice(product) {
    this.displaySearchLoader = true
    this.shoppingCartService.checkPrice(product).subscribe(
      (data) => {
        if (!data['errors']) {
          this.checkPriceProduct[product.code] = {
            display: true,
            code: product.code,
            price: data['price'],
            status: 'BUY',
          }
          if (
            (this.product.quotabilityFlag && this.product.sellabilityFlag) ||
            (this.product.sellabilityFlag && !this.product.quotabilityFlag)
          ) {
            this.checkPriceProduct[product.code].status = 'BUY'
          } else if (
            this.product.quotabilityFlag &&
            !this.product.sellabilityFlag
          ) {
            this.checkPriceProduct[product.code].status = 'QUOTE'
          }
          this.sellabilityAfterPriceCheck = true
          this.displaySearchLoader = false
          this.emitCheckPriceProductObj.emit(this.checkPriceProduct)
          this.hideProductPrice = false
          this.cd.detectChanges()
        } else {
          this.hideProductPrice = false
          this.displaySearchLoader = false
          this.checkPriceErrorHandling(data, product)
          this.emitCheckPriceProductObj.emit(this.checkPriceProduct)
          this.cd.detectChanges()
        }
      },
      (error) => {
        this.hideProductPrice = false
        this.displaySearchLoader = false
        this.checkPriceErrorHandling(error, product)
        this.emitCheckPriceProductObj.emit(this.checkPriceProduct)
        this.cd.detectChanges()
      }
    )
  }

  checkPriceErrorHandling(data, product) {
    if (data?.error?.errors !== undefined) {
      if (data?.error?.errors[0]?.errorCode === '5001') {
        this.checkPriceProduct[product.code] = {
          display: true,
          code: product.code,
          price: undefined,
          status: 'QUOTE',
        }
        this.cd.detectChanges()
        this.displaySearchLoader = false
        if (this.view == 'list' || this.view == 'grid') {
          this.priceNotFound.emit(true)
        } else {
          this.globalMessageService.add(
            { key: 'addCart.priceNotAvailable2' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      } else if (
        data?.error?.errors[0]?.message === '500' ||
        data?.error?.errors[0]?.errorCode === '500'
      ) {
        this.displaySearchLoader = false
        // this.displayErrorOnScreen();
        this.globalMessageService.add(
          { key: 'addCart.errorConnectingSAP' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    } else {
      this.displaySearchLoader = false
      this.displayErrorOnScreen()
    }
  }

  displayErrorOnScreen() {
    this.globalMessageService.add(
      { key: 'addCart.requestCantBeProcessed' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  // CHECK PRICE CUSTOMIZATION FOR GLOBAL SEARCH  - END
  dateChange(event) {
    this.committedDate =
      event.getFullYear() +
      '/' +
      this.getMonth(event) +
      '/' +
      event.getDate().toString().padStart(2, '0');

    this.product.committedDate = this.committedDate;
    
    this.checkForAvailability();
  }
  getMonth(event) {
    if ((Number(event.getMonth()) + 1) / 10 < 1) {
      return (Number(event.getMonth()) + 1).toString().padStart(2, '0')
    }
    if ((Number(event.getMonth()) + 1) / 10 >= 1) {
      return Number(event.getMonth()) + 1
    }
  }

  checkAvailabilityCall(flag) {
    if (!this.spinnerOverlayService.getOverlayRef().hasAttached()) {
      this.spinnerOverlayService.show()
    }
    // this.spinnerOverlayService.show();
    this.showAvailability = true
    // this.showDiffPlantWarning = false;
    const availableObj = {
      quantity: this.quantity,
      // selectedLegalEntity: this.product.defaultSalesArea,
      customerRequestedDate: this.product?.committedDate,
      selectedPlant: this.legalEntityData,
    }
    if (flag == true) {
      availableObj.selectedPlant = null
    }
    const apiParams = ['products', 'productCode']
    let lastPart = `checkPriceAndAvailability?`
    lastPart += `productCode=${encodeURIComponent(this.productCode)}`
    apiParams.push(lastPart)
    // const apiParams = ['products', this.productCode, 'checkPriceAndAvailability'];
    const apiUrl = this.commonService.constructUrl(apiParams)
    this.availabilityInfo$ = this.commonService.postData(apiUrl, availableObj)
    this.availabilityInfo$.subscribe(
      (data) => {
        if (data?.availabilityDetail){
          this.commitedDateToCheck = data?.availabilityDetail[0].committedDate
          this.availabilityDetails = data?.availabilityDetail
        }
        this.showAvailability = false
        this.cd.detectChanges()
        //this.priceAvailabilityProductObj.emit(data);
        this.commonService.priceandAvailabilitySource.next(
          this.availabilityInfo$
        )
        this.spinnerOverlayService.hide()
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'addCart.unknownErrorOccured' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  changeLegalEntity(event) {
    // if (event.uid != this.legalEntityData.uid) {
    if (event.code != this.legalEntityData?.code && !event?.defaultPlant) {
      this.showDiffPlantWarning = true
    } else {
      this.showDiffPlantWarning = false
    }
    this.legalEntityData = event
    this.selectedLegalEntityId = event.code
    this.checkForAvailability()
  }
  checkForAvailability() {
    let count = 0
    this.product?.plantAvailableAt.forEach((element) => {
      if (element?.code === this.legalEntityData?.code) {
        count++
      }
    })
    if (count === 1) {
      this.showAvailability = true
      this.showNotAvailableMsg = false
    } else {
      this.showAvailability = false
      this.showNotAvailableMsg = true
    }
  }

  pushAddToCartEvent(productData, cart_type, cartId) {
    const item: EcommerceItem = {
      price: productData?.netPrice?.value,
      quantity: this.addToCartForm.get('quantity').value,
      item_id: (cart_type == 'buy') ? productData?.product.code : productData?.code,
      item_name: (cart_type == 'buy') ? productData?.product.name : productData?.name,
      item_list_id: ItemListTypeEnum.ProductDetail,
      item_list_name: ItemListTypeEnum.ProductDetail,
      item_category: (cart_type == 'buy') ? (productData?.product?.categories?.[0]?.name || '') : (productData?.categories?.[0]?.name || ''),
      item_category2: (cart_type == 'buy') ? (productData?.product?.categories?.[1]?.name || '') : (productData?.categories?.[1]?.name || ''),
      item_category3: (cart_type == 'buy') ? (productData?.product?.categories?.[2]?.name || '') : (productData?.categories?.[2]?.name || ''),
      item_category4: (cart_type == 'buy') ? (productData?.product?.categories?.[3]?.name || '') : (productData?.categories?.[3]?.name || ''),
      item_category5: (cart_type == 'buy') ? (productData?.product?.categories?.[4]?.name || '') : (productData?.categories?.[4]?.name || ''),
      item_variant: '',
      index: 0,
    };

    const eventData: Ecommerce = {
      currency: productData?.netPrice?.currencyIso || '',
      value:
        productData?.netPrice?.value *
          this.addToCartForm.get('quantity').value || '',
      items: [item],
    };
    const event: GTMDataLayer = {
      event: GtmEvents.AddToCart,
      ecommerce: eventData,
      commerceType: (cart_type == 'buy') ? GTMCartType.BUY_CART : GTMCartType.QUOTE_CART,
      cart_id: cartId
    };
    this.gtmService.sendEvent(event);
  }
}
